<div class="spinner" *ngIf="showSpinner">
  <mat-spinner></mat-spinner>
</div>

<div class="page-container">
  <div class="title-map-wrapper">
    <div class="titles-holder">
      <div class="merck-font-title">SPECS footprint dashboard</div>
      <div class="sub-title">Welcome to SPECS Footprint dashboard!</div>
    </div>
    <div class="map">
      <app-mecs-map
        [config]="mapConfig"
        (clickedRegion)="onRegionClick($event)"
      ></app-mecs-map>
    </div>
  </div>

  <div class="map-information-holder">
    <div class="in-depth-button" (click)="goToInDepth()">
      <div>In-depth status update by country and solution</div>
      <img src="assets/images/button-arrow-right.png" alt="" />
    </div>

    <div class="information-holder">
      <img class="info-icon" src="assets/images/info_purple_icon.png" alt="" />
      <div>Pick the relevant region</div>
    </div>
  </div>

  <app-mecs-kpi-filter (filter)="getFilterData($event)"></app-mecs-kpi-filter>

  <div class="dashboard-data-holder">
    <div class="information-holder">
      <div class="information-left-section-holder">
        <app-mecs-implementation-status
          [subheading]="'Global view'"
          [data]="countriesData.implementationStatus"
        ></app-mecs-implementation-status>

        <div class="countries">
          <div class="top-countries">
            <div class="title">
              <p class="heading">Top countries</p>
              <p class="subheading">
                Top countries by # of number of launched solutions
              </p>
            </div>

            <div class="countries-wrapper">
              <empty-state
                *ngIf="countriesData.topCountries.length === 0"
              ></empty-state>
              <div
                class="country-wrapper"
                *ngFor="
                  let country of countriesData.topCountries;
                  let i = index
                "
              >
                <p [style.color]="countriesColors.get(i)" class="country">
                  {{ i + 1 + ". " + country.name }}
                </p>
                <p
                  [style.color]="countriesColors.get(i)"
                  class="potential-amount"
                >
                  {{ country.numberOfSolutions }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="information-right-section-holder">
        <div class="global-overview">
          <div class="title-pagination">
            <p class="heading">Global overview</p>

            <div class="pagination" *ngIf="totalPagesGlobalOverview > 1">
              <span
                class="arrow"
                (click)="goToPageGlobalOverivew(currentPageGlobalOverview - 1)"
                [class.disabled]="currentPageGlobalOverview === 1"
                >&#x276E;</span
              >

              <span
                *ngFor="let page of pagesGlobalOverview"
                class="page-number"
                [class.active]="page === currentPageGlobalOverview"
                (click)="goToPageGlobalOverivew(page)"
                >{{ page }}</span
              >

              <span
                class="arrow"
                (click)="goToPageGlobalOverivew(currentPageGlobalOverview + 1)"
                [class.disabled]="currentPageGlobalOverview === totalPagesGlobalOverview"
                >&#x276F;</span
              >
            </div>
          </div>

          <empty-state
            class="table-holder"
            *ngIf="countriesData.globalOverview.length === 0"
          ></empty-state>

          <div class="overview-holder">
            <div class="overivew-box" *ngFor="let item of paginatedGlobalOverview">
              <div class="counter-information">
                <div class="counter">{{ item.numberOfUserCountries }}</div>
                <div class="information">
                  Current total # countries that have launched
                </div>
              </div>
              <div class="project-information">{{ item.projectName }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="table-wrapper">
      <div class="title-pagination">
        <p class="heading">Overview of solution launches by region</p>

        <div class="pagination" *ngIf="totalPagesSolutionLaunches > 1">
          <span
            class="arrow"
            (click)="goToPageSolutionLaunches(currentSolutionsLaunchPage - 1)"
            [class.disabled]="currentSolutionsLaunchPage === 1"
            >&#x276E;</span
          >

          <span
            *ngFor="let page of pagesSolutionLaunches"
            class="page-number"
            [class.active]="page === currentSolutionsLaunchPage"
            (click)="goToPageSolutionLaunches(page)"
            >{{ page }}</span
          >

          <span
            class="arrow"
            (click)="goToPageSolutionLaunches(currentSolutionsLaunchPage + 1)"
            [class.disabled]="currentSolutionsLaunchPage === totalPagesSolutionLaunches"
            >&#x276F;</span
          >
        </div>
      </div>
      <empty-state
        class="table-holder"
        *ngIf="dataSource.length === 0"
      ></empty-state>

      <mat-table
        class="table-holder"
        [dataSource]="dataSource"
        *ngIf="dataSource.length > 0"
      >
        <ng-container [matColumnDef]="'region'">
          <mat-header-cell *matHeaderCellDef class="transparent-no-border" #regionCell >
          </mat-header-cell>
          <mat-cell *matCellDef="let data" class="region-info"  >
            {{ data.regionName }}
            <img [src]="data.iconUrl" />
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="header-row-region">
          <mat-header-cell
            class="transparent-no-border"
            *matHeaderCellDef
            [style.flex-basis]="regionFlexBasis"
          ></mat-header-cell>
        </ng-container>

        <ng-container  *ngFor="let item of productHeaders" [matColumnDef]="item">
          <mat-header-cell class="cp-header"  [style.flex-basis]="columnsFlexBasis"  *matHeaderCellDef>
            {{ item }}
          </mat-header-cell>
        </ng-container>

        <ng-container
          *ngFor="let item of productHeaders"
          [matColumnDef]="item + '-launched'"
        >
          <mat-header-cell *matHeaderCellDef class="purple-text subheader">
            Launched
          </mat-header-cell>
          <mat-cell
            *matCellDef="let data"
            style="font-size: 12px"
            class="phase-text"
          >
            {{ getProductData(data, item).launched }} /
            {{ getProductData(data, item).total }}
          </mat-cell>
        </ng-container>

        <ng-container
          *ngFor="let item of productHeaders"
          [matColumnDef]="item + '-countries'"
        >
          <mat-header-cell *matHeaderCellDef class="purple-text subheader">
            Top Countries
          </mat-header-cell>
          <mat-cell *matCellDef="let data" class="purple-text">
            {{ getProductData(data, item).topCountries }}
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="headerRows"></mat-header-row>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
    </div>

    <div class="table-wrapper">
      <div class="title">
        <p class="heading">
          Overview of the number of countries by solution and their current
          phase
        </p>
      </div>
      <empty-state
        class="table-holder"
        *ngIf="dataSourceCountryPhase.length === 0"
      ></empty-state>

      <mat-table
        class="table-holder"
        [dataSource]="dataSourceCountryPhase"
        *ngIf="dataSourceCountryPhase.length > 0"
      >
        <ng-container [matColumnDef]="'solutions'">
          <mat-header-cell *matHeaderCellDef class="solutions-column">
            SOLUTIONS
          </mat-header-cell>
          <mat-cell *matCellDef="let data" class="solutions-text">
            {{ data.projectName }}
          </mat-cell>
        </ng-container>

        <ng-container [matColumnDef]="'planing'">
          <mat-header-cell
            *matHeaderCellDef
            style="background-color: #a7d4f1"
            class="country-header"
          >
            PLANNING PHASE</mat-header-cell
          >
          <mat-cell *matCellDef="let data" class="phase-text">
            {{ data.planingPhaseCountries }}
          </mat-cell>
        </ng-container>

        <ng-container [matColumnDef]="'pre-launch'">
          <mat-header-cell
            *matHeaderCellDef
            style="background-color: #f9d269"
            class="country-header"
          >
            PRE-LAUNCH PHASE</mat-header-cell
          >
          <mat-cell *matCellDef="let data" class="phase-text">
            {{ data.preLaunchPhaseCountries }}
          </mat-cell>
        </ng-container>

        <ng-container [matColumnDef]="'launch'">
          <mat-header-cell
            *matHeaderCellDef
            style="background-color: #84cbb0"
            class="country-header"
          >
            LAUNCH PHASE</mat-header-cell
          >
          <mat-cell *matCellDef="let data" class="phase-text">
            {{ data.launchPhaseCountries }}
          </mat-cell>
        </ng-container>

        <ng-container [matColumnDef]="'on-hold'">
          <mat-header-cell
            *matHeaderCellDef
            style="background-color: #ec7169"
            class="country-header"
          >
            ON-HOLD PHASE</mat-header-cell
          >
          <mat-cell *matCellDef="let data" class="phase-text">
            {{ data.onHoldPhaseCountries }}
          </mat-cell>
        </ng-container>

        <mat-header-row
          *matHeaderRowDef="displayedColumnsProjectPhase"
        ></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumnsProjectPhase"
        ></mat-row>
      </mat-table>
    </div>
  </div>
</div>
